import { lazy } from "react"
import { RouteProps } from "../features.types"

const AddVehicleController = lazy(
  () => import("./add-vehicle/add-vehicle-controller")
)
const AddVehicleHome = lazy(() => import("./add-vehicle/add-vehilce"))
const AddVehicleOne = lazy(() => import("./add-vehicle/add-vehicle-one"))
const AddVehicleTwo = lazy(() => import("./add-vehicle/add-vehicle-two"))
const AddVehicleBulk = lazy(() => import("./add-vehicle/add-vehicle-bulk"))
const EditVehicleController = lazy(
  () => import("./edit-vehicle/edit-vehicle-controller")
)
const EditVehicleHome = lazy(() => import("./edit-vehicle/edit-vehicle"))

// define route constant
export const ADD_VEHICLE_ROUTE = "vehicle/add"
export const ADD_VEHICLE_ROUTE_ONE = "vehicle/add/1"
export const ADD_VEHICLE_ROUTE_TWO = "vehicle/add/2"
export const ADD_VEHICLE_ROUTE_BULK = "vehicle/add/bulk"

// define edit route constants
export const EDIT_VEHICLE_ROUTE = "vehicle/edit"

//define routes
export const Vehicle: RouteProps[] = [
  {
    path: ADD_VEHICLE_ROUTE,
    Component: AddVehicleController,
    children: [
      {
        index: true,
        Component: AddVehicleHome,
      },
      {
        path: `/${ADD_VEHICLE_ROUTE_ONE}`,
        Component: AddVehicleOne,
      },
      {
        path: `/${ADD_VEHICLE_ROUTE_TWO}`,
        Component: AddVehicleTwo,
      },
      {
        path: `/${ADD_VEHICLE_ROUTE_BULK}`,
        Component: AddVehicleBulk,
      },
    ],
  },
  {
    path: EDIT_VEHICLE_ROUTE,
    Component: EditVehicleController,
    children: [
      {
        index: true,
        Component: EditVehicleHome,
      },
    ],
  },
]
